import React from "react";

function notFound() {
  return <h1>404</h1>;
}

export default notFound;
